export const environment = {
  production: false,
  hubURL: 'https://devapi.launch57.com/cbs/auction',
  apiURL: 'https://devapi.launch57.com/cbs/api',
  clientUrl: 'https://qaapp.bidbeacon.com/',
  rrUrl: 'https://qago.raffle-rocket.com',
  webUrl: 'https://qaapp.bidbeacon.com',
  rrApiUrl: 'https://devapi.raffle-rocket.com/api',
  cbsDashUrl: 'https://qamanage.communibee.ca',
  cbsClientRootUrl: 'https://qaexplore.communibee.ca/cbs',
  gtmId: 'GTM-N6SNB9V'
};
